module.exports = "/_next/static/images/Security-xs@2x-6ec76d08b12cbbfcfa2f697e294be854.png";